





































import { Component, Mixins } from 'vue-property-decorator';
import { mapState } from 'vuex';
import GlobalOverlayCloseButton from '@/components/Globals/Overlay/Components/Buttons/GlobalOverlayCloseButton.vue';
import GlobalOverlayEmptyButton from '@/components/Globals/Overlay/Components/Buttons/GlobalOverlayEmptyButton.vue';
import GlobalOverlayBellButton from '@/components/Globals/Overlay/Components/Buttons/GlobalOverlayBellButton.vue';
import GlobalOverlayMethods from '@/mixins/GlobalOverlayMethods.vue';

@Component({
    name: 'GlobalOverlay',
    computed: {
        ...mapState('GlobalOverlay', [
            'globalOverlayVisibility',
        ]),
    },
    components: {
        GlobalOverlayCloseButton,
        GlobalOverlayEmptyButton,
        GlobalOverlayBellButton,
        TenantNotifications: () => import('@/components/Globals/Overlay/Components/Lists/TenantNotifications.vue'),
        StaffCreateTicketForm: () => import('@/components/Admin/Forms/StaffCreateTicketForm.vue'),
        StaffCreateTicketNote: () => import('@/components/Admin/Forms/StaffCreateTicketNote.vue'),
        FilterStaffTicketsList: () => import('@/components/Globals/Overlay/Components/Lists/FilterStaffTicketsList.vue'),
    },
    watch: {
        globalOverlayVisibility(newValue) {
            if (newValue) {
                this.$nextTick(() => {
                    const dialog = document.getElementById('hoc-global-overlay');

                    if (dialog) {
                        // @ts-ignore
                        dialog.className += ' ' + this.globalOverlayConfig.dialogClasses;
                    }
                });
            }
        },
    },
})
export default class GlobalOverlay extends Mixins(
    GlobalOverlayMethods,
) {
    constructor() {
        super();
    }

    get withHeader() {
        return (
            this.globalOverlayConfig.title ||
            this.globalOverlayConfig.leftButtonComponent ||
            this.globalOverlayConfig.rightButtonComponent
        );
    }

    public onLoad(ev: any) {
        const el = document.querySelectorAll('.global-layout .scroll')[0];

        if (el.scrollHeight - el.scrollTop - el.clientHeight < 1) {
            const component = this.$refs.component as any;

            if (component && typeof component.load !== 'undefined') {
                component.load();
            }
        }
    }
}
